/* eslint-disable max-params */
import { normalizeUrl } from '@sisense/sdk-common';
import { BearerAuthenticator } from './bearer-authenticator.js';
import { FusionAuthenticator } from './fusion-authenticator.js';
import { PasswordAuthenticator } from './password-authenticator.js';
import { SsoAuthenticator } from './sso-authenticator.js';
import { WatAuthenticator } from './wat-authenticator.js';
export function getAuthenticator({ url: rawUrl, username, password, token, wat, ssoEnabled = false, enableSilentPreAuth = false, useFusionAuth = false, alternativeSsoHost = '', }) {
    const url = normalizeUrl(rawUrl);
    // sso overrides all other auth methods
    if (ssoEnabled) {
        return new SsoAuthenticator(normalizeUrl(rawUrl, true), enableSilentPreAuth, alternativeSsoHost);
    }
    // username/password or tokens are chosen relative to priority
    if (username && password) {
        return new PasswordAuthenticator(url, username, password);
    }
    if (token) {
        return new BearerAuthenticator(url, token);
    }
    if (wat) {
        return new WatAuthenticator(url, wat);
    }
    if (useFusionAuth) {
        return new FusionAuthenticator();
    }
    return null;
}
//# sourceMappingURL=authenticator.js.map